import { createApi } from '@reduxjs/toolkit/query/react';

import { apiAccessTags } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export const typePrefix = `access-tags`;

export interface AccessTag {
  id: string;
  name: string;
  module: string;
  permission: string;
  access_tag: string;
}

export const accessTagsApi = createApi({
  reducerPath: 'accessTagsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiAccessTags }),
  tagTypes: ['accessTags'],
  endpoints: (builder) => ({
    getAccessTags: builder.query<AccessTag[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'accessTags', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AccessTag[]>(payload),
    }),
  }),
});

export const { useGetAccessTagsQuery } = accessTagsApi;
